import { Navigate, Route, Routes } from 'react-router-dom';

import { AuthGate } from './auth/AuthGate';
import { Layout } from './components/Layout';
import { Approvals } from './pages/Approvals';
import { CaseDetail } from './pages/CaseDetail';
import { Cases } from './pages/Cases';
import { Dashboard } from './pages/Dashboard';
import { Health } from './pages/Health';
import { NotFound } from './pages/NotFound';
import { Settings } from './pages/Settings';

export function App() {
  return (
    <AuthGate>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="cases" element={<Cases />} />
          <Route path="cases/:caseId" element={<CaseDetail />} />
          <Route path="approvals" element={<Approvals />} />
          {/*
            Health renders its own denial rather than being route-guarded. A redirect would
            tell an operator the page does not exist when the real answer is that they lack
            IRA.Admin — which is actionable.
          */}
          <Route path="health" element={<Health />} />
          <Route path="settings" element={<Settings />} />
          <Route path="index.html" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AuthGate>
  );
}
